// This file is auto-generated by @hey-api/openapi-ts

import { type Options, AppConfigService, BasketService, BasketCommitStatusService, CareCompanionService, ClientAppService, ClientAppointmentsService, ClientAuthMethodsService, ClientBookableTimeLocksService, ClientCasesService, ClientConditionsService, ClientDropInService, ClientFormsService, ClientGuiComponentsService, ClientIdentityService, ClientMessagingService, ClientMessagingCompletionService, ClientNotificationTargetsService, ClientPaymentsService, ClientReceptionConditionsService, ClientRegistrationService, ClientSmsService, ClientSurveysService, ClientThemeService, ClientTimeslotsService, ClientUnitsService, ClientUsageAgreementsService, CurrencyService, DemandManagementService, ExternalDataService, HomeGuiComponentsService, IdentityIdpService, IdpAuthMethodsService, InformationGatheringService, LocaleService, NavigationService, NotificationSettingsService, PaymentsService, PhysicalLocationsService, RateService, RecentReceptionsService, ReceptionService, RedRobinService, SearchLimitationService, SessionInformationService, TranslationSetsService, UnitsPhysicalLocationsService, UserFilesService } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError } from '@tanstack/react-query';
import type { AppConfigGetData, BasketDeleteActiveBasketData, BasketDeleteActiveBasketError, BasketDeleteActiveBasketResponse, BasketGetActiveBasketData, BasketDeleteBasketData, BasketDeleteBasketError, BasketDeleteBasketResponse, BasketGetBasketData, BasketAddMessagingProductData, BasketAddMessagingProductError, BasketAddMessagingProductResponse, BasketSelectParticipantData, BasketSelectParticipantResponse, BasketDeselectParticipantData, BasketDeselectParticipantResponse, BasketDeleteFilesData, BasketDeleteFilesError, BasketDeleteFilesResponse, BasketAddFilesData, BasketAddFilesError, BasketAddFilesResponse, BasketGetExternalDataData, BasketSetExternalDataData, BasketSetExternalDataError, BasketSetExternalDataResponse, BasketSetReasonData, BasketSetReasonError, BasketSetReasonResponse, BasketRemoveItemsData, BasketRemoveItemsError, BasketRemoveItemsResponse, BasketGetFormAnswersData, BasketSetFormAnswersData, BasketSetFormAnswersError, BasketSetFormAnswersResponse, BasketPreCommitData, BasketPreCommitError, BasketPreCommitResponse, BasketDeleteCommitData, BasketDeleteCommitError, BasketDeleteCommitResponse, BasketCommitStatusQueryCommitStatusActionData, BasketContinueCommitData, BasketContinueCommitError, BasketContinueCommitResponse, BasketCreateCommitData, BasketCreateCommitError, BasketCreateCommitResponse, BasketCreateCommitOldData, BasketCreateCommitOldError, BasketCreateCommitOldResponse, CareCompanionCreateSessionData, CareCompanionCreateSessionError, CareCompanionCreateSessionResponse, CareCompanionEndSessionData, CareCompanionEndSessionError, CareCompanionEndSessionResponse, PrivacyPolicyWebInfoData, ClientAppPointToPrivacyPolicyData, ClientAppPointToTermsOfServiceData, ClientAppGetConfigData, ClientAppointmentsGetUpcomingAndUnfinishedData, ClientAppointmentsCancelData, ClientAppointmentsCancelError, ClientAppointmentsCancelResponse, ClientAppointmentsGetData, ClientAppointmentsGetCallStatusData, ClientAppointmentsDeclineData, ClientAppointmentsDeclineError, ClientAppointmentsDeclineResponse, ClientAppointmentsUpdateLegalGuardiansData, ClientAppointmentsUpdateLegalGuardiansError, ClientAppointmentsUpdateLegalGuardiansResponse, ClientAppointmentsAddFileData, ClientAppointmentsAddFileError, ClientAppointmentsAddFileResponse, ClientAuthMethodsGetAuthMethodsData, ClientBookableTimeLocksCreateLockData, ClientBookableTimeLocksCreateLockError, ClientBookableTimeLocksCreateLockResponse, ClientBookableTimeLocksReleaseLockData, ClientBookableTimeLocksReleaseLockError, ClientBookableTimeLocksReleaseLockResponse, ClientBookableTimeLocksExtendLockData, ClientBookableTimeLocksExtendLockError, ClientBookableTimeLocksExtendLockResponse, ClientCasesListUpdatesData, ClientCasesMarkNewAppointmentSeenData, ClientCasesMarkNewAppointmentSeenError, ClientCasesMarkNewAppointmentSeenResponse, ClientCasesPrioritizedV2Data, ClientConditionsListData, ClientDropInEnqueueData, ClientDropInEnqueueError, ClientDropInEnqueueResponse, ClientDropInCancelData, ClientDropInCancelError, ClientDropInCancelResponse, ClientDropInGetTicketData, GetActiveTicketData, GetActiveTicketForRoomData, ClientDropInUploadData, ClientDropInUploadError, ClientDropInUploadResponse, ClientDropInListData, ClientDropInGetData, ClientDropInGetByUrlAliasData, ClientFormsListData, ClientFormsGetFormGraphData, ClientFormsGetRespondantData, ClientFormsSaveAnswersData, ClientFormsSaveAnswersError, ClientFormsSaveAnswersResponse, ClientFormsSetRespondantCompleteData, ClientFormsSetRespondantCompleteError, ClientFormsSetRespondantCompleteResponse, ClientGuiComponentsListData, ClientIdentityDeleteData, ClientIdentityDeleteError, ClientIdentityDeleteResponse, ClientIdentityGetData, ClientIdentityUpdateData, ClientIdentityUpdateError, ClientIdentityUpdateResponse, ClientIdentityInviteablePersonsData, ClientIdentityCanDeleteData, ClientIdentitySignOutData, ClientIdentitySignOutError, ClientIdentitySignOutResponse, ClientIdentityIsAliveData, ClientIdentityIsAliveOutsiderData, ClientMessagingListData, ClientMessagingGetData, ClientMessagingGetCaseData, ClientMessagingUpdateLegalGuardiansData, ClientMessagingUpdateLegalGuardiansError, ClientMessagingUpdateLegalGuardiansResponse, ClientMessagingCompletionCompleteCaseData, ClientMessagingCompletionCompleteCaseError, ClientMessagingCompletionCompleteCaseResponse, ClientNotificationTargetsDeleteStandardTargetData, ClientNotificationTargetsDeleteStandardTargetError, ClientNotificationTargetsDeleteStandardTargetResponse, ClientNotificationTargetsSetStandardTargetData, ClientNotificationTargetsSetStandardTargetError, ClientNotificationTargetsSetStandardTargetResponse, ClientNotificationTargetsDeleteVoipTargetData, ClientNotificationTargetsDeleteVoipTargetError, ClientNotificationTargetsDeleteVoipTargetResponse, ClientNotificationTargetsSetVoipTargetData, ClientNotificationTargetsSetVoipTargetError, ClientNotificationTargetsSetVoipTargetResponse, ClientPaymentsPaymentServicesData, ClientReceptionConditionsListData, ClientRegistrationGetRegistrationData, ClientRegistrationCompleteRegistrationData, ClientRegistrationCompleteRegistrationError, ClientRegistrationCompleteRegistrationResponse, ClientSmsStartAuthData, ClientSmsStartAuthError, ClientSmsStartAuthResponse, ClientSmsStartAuthWithCallTicketData, ClientSmsStartAuthWithCallTicketError, ClientSmsStartAuthWithCallTicketResponse, ClientSmsReSendCodeData, ClientSmsReSendCodeError, ClientSmsReSendCodeResponse, ClientSmsConfirmCodeData, ClientSmsConfirmCodeError, ClientSmsConfirmCodeResponse, ClientSmsPreRegisteredNumberData, ClientSurveysGetSurveyData, ClientSurveysAnswerSurveyData, ClientSurveysAnswerSurveyError, ClientSurveysAnswerSurveyResponse, ClientThemeGetPublicThemeData, ClientTimeslotsTimeslotsData, ClientTimeslotsTimeslotData, ClientTimeslotsSearchLocalityAvailabilityData, ClientTimeslotsGetAvailabilityCountsData, ClientTimeslotsGetSearchCapabilitiesData, ClientTimeslotsBookSlotData, ClientTimeslotsBookSlotError, ClientTimeslotsBookSlotResponse, ClientTimeslotsGetRescheduleTimeslotsData, ClientTimeslotsRebookWithNewTimeslotData, ClientTimeslotsRebookWithNewTimeslotError, ClientTimeslotsRebookWithNewTimeslotResponse, ClientTimeslotsGetRescheduleAvailabilityCountsData, ClientUnitsListUnitsData, ClientUnitsGetData, ClientUnitsGetThemeData, ClientUnitsGetAboutData, ClientUnitsGetTextsData, ClientUnitsGetIdentifierConflictsData, ClientUsageAgreementsGetDocumentsData, ClientUsageAgreementsAgreeToDocumentData, ClientUsageAgreementsAgreeToDocumentError, ClientUsageAgreementsAgreeToDocumentResponse, CurrencyGetData, DemandManagementIsMessagingOpenData, DemandManagementIsTriageOpenData, DemandManagementGetRuleSetData, ExternalDataUploadExternalDataData, ExternalDataUploadExternalDataError, ExternalDataUploadExternalDataResponse, HomeGuiComponentsListDeprecatedData, HomeGuiComponentsListData, IdentityIdpSignOutIdpData, IdentityIdpSignOutIdp2Data, IdpAuthMethodsGetAuthMethodsData, InformationGatheringGetEligibilityData, InformationGatheringStoreSubmissionData, InformationGatheringStoreSubmissionError, InformationGatheringStoreSubmissionResponse, LocaleGetData, NavigationStartData, NavigationStartError, NavigationStartResponse, NotificationSettingsGetComplianceSettingsData, NotificationSettingsUpdateComplianceSettingsData, NotificationSettingsUpdateComplianceSettingsError, NotificationSettingsUpdateComplianceSettingsResponse, PaymentsGetBillData, PhysicalLocationsGetPhysicalLocationData, PhysicalLocationsGetPhysicalLocationsData, RateGetMessagingPriceData, RecentReceptionsListRecentlyVisitedData, RecentReceptionsRegisterVisitData, RecentReceptionsRegisterVisitError, RecentReceptionsRegisterVisitResponse, RecentReceptionsDeleteVisitData, RecentReceptionsDeleteVisitError, RecentReceptionsDeleteVisitResponse, ReceptionListFromUnitIdData, ReceptionSearchData, RedRobinStartSessionData, RedRobinStartSessionError, RedRobinStartSessionResponse, RedRobinStartSessionV2Data, RedRobinStartSessionV2Error, RedRobinStartSessionV2Response, RedRobinGetPatientEntryUrlData, RedRobinGetAccessInfoData, SearchLimitationDeleteContextData, SearchLimitationDeleteContextError, SearchLimitationGetSearchLimitationData, SearchLimitationCreateSearchLimitationData, SearchLimitationCreateSearchLimitationResponse, SessionInformationGetClientSessionInformationData, SessionInformationGetGuestSessionInformationData, TranslationSetsGetData, UnitsPhysicalLocationsGetPhysicalLocationsData, UserFilesGetFileIdentifierData, UserFilesGetFileIdentifierError, UserFilesGetFileIdentifierResponse } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const appConfigGetQueryKey = (options: Options<AppConfigGetData>) => createQueryKey('appConfigGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.AppConfigController
 */
export const appConfigGetOptions = (options: Options<AppConfigGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppConfigService.appConfigGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appConfigGetQueryKey(options)
    });
};

/**
 * Deletes the active basket for the given reception.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketDeleteActiveBasketMutation = (options?: Partial<Options<BasketDeleteActiveBasketData>>): UseMutationOptions<BasketDeleteActiveBasketResponse, BasketDeleteActiveBasketError, Options<BasketDeleteActiveBasketData>> => {
    const mutationOptions: UseMutationOptions<BasketDeleteActiveBasketResponse, BasketDeleteActiveBasketError, Options<BasketDeleteActiveBasketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketDeleteActiveBasket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const basketGetActiveBasketQueryKey = (options: Options<BasketGetActiveBasketData>) => createQueryKey('basketGetActiveBasket', options);

/**
 * Gets or creates the active basket for the given reception.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketGetActiveBasketOptions = (options: Options<BasketGetActiveBasketData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await BasketService.basketGetActiveBasket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: basketGetActiveBasketQueryKey(options)
    });
};

/**
 * Deletes a basket by id.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketDeleteBasketMutation = (options?: Partial<Options<BasketDeleteBasketData>>): UseMutationOptions<BasketDeleteBasketResponse, BasketDeleteBasketError, Options<BasketDeleteBasketData>> => {
    const mutationOptions: UseMutationOptions<BasketDeleteBasketResponse, BasketDeleteBasketError, Options<BasketDeleteBasketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketDeleteBasket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const basketGetBasketQueryKey = (options: Options<BasketGetBasketData>) => createQueryKey('basketGetBasket', options);

/**
 * Gets the contents of a basket.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketGetBasketOptions = (options: Options<BasketGetBasketData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await BasketService.basketGetBasket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: basketGetBasketQueryKey(options)
    });
};

/**
 * Adds a messaging conversation product to the basket.
 * If the client is currently representing another person, participants (the subject and their legal guardians)
 * are resolved automatically via the PU service and returned in the result. The acting client is excluded
 * from the guardian list. Participants are initially unselected.
 */
export const basketAddMessagingProductMutation = (options?: Partial<Options<BasketAddMessagingProductData>>): UseMutationOptions<BasketAddMessagingProductResponse, BasketAddMessagingProductError, Options<BasketAddMessagingProductData>> => {
    const mutationOptions: UseMutationOptions<BasketAddMessagingProductResponse, BasketAddMessagingProductError, Options<BasketAddMessagingProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketAddMessagingProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Marks a participant as selected for inclusion when the basket is committed.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketSelectParticipantMutation = (options?: Partial<Options<BasketSelectParticipantData>>): UseMutationOptions<BasketSelectParticipantResponse, DefaultError, Options<BasketSelectParticipantData>> => {
    const mutationOptions: UseMutationOptions<BasketSelectParticipantResponse, DefaultError, Options<BasketSelectParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketSelectParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Marks a participant as deselected so they are not included when the basket is committed.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketDeselectParticipantMutation = (options?: Partial<Options<BasketDeselectParticipantData>>): UseMutationOptions<BasketDeselectParticipantResponse, DefaultError, Options<BasketDeselectParticipantData>> => {
    const mutationOptions: UseMutationOptions<BasketDeselectParticipantResponse, DefaultError, Options<BasketDeselectParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketDeselectParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletes file references from a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketDeleteFilesMutation = (options?: Partial<Options<BasketDeleteFilesData>>): UseMutationOptions<BasketDeleteFilesResponse, BasketDeleteFilesError, Options<BasketDeleteFilesData>> => {
    const mutationOptions: UseMutationOptions<BasketDeleteFilesResponse, BasketDeleteFilesError, Options<BasketDeleteFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketDeleteFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Adds file references to a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketAddFilesMutation = (options?: Partial<Options<BasketAddFilesData>>): UseMutationOptions<BasketAddFilesResponse, BasketAddFilesError, Options<BasketAddFilesData>> => {
    const mutationOptions: UseMutationOptions<BasketAddFilesResponse, BasketAddFilesError, Options<BasketAddFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketAddFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const basketGetExternalDataQueryKey = (options: Options<BasketGetExternalDataData>) => createQueryKey('basketGetExternalData', options);

/**
 * Gets external data references for a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketGetExternalDataOptions = (options: Options<BasketGetExternalDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await BasketService.basketGetExternalData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: basketGetExternalDataQueryKey(options)
    });
};

/**
 * Sets external data references on a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketSetExternalDataMutation = (options?: Partial<Options<BasketSetExternalDataData>>): UseMutationOptions<BasketSetExternalDataResponse, BasketSetExternalDataError, Options<BasketSetExternalDataData>> => {
    const mutationOptions: UseMutationOptions<BasketSetExternalDataResponse, BasketSetExternalDataError, Options<BasketSetExternalDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketSetExternalData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sets the reason for visit on a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketSetReasonMutation = (options?: Partial<Options<BasketSetReasonData>>): UseMutationOptions<BasketSetReasonResponse, BasketSetReasonError, Options<BasketSetReasonData>> => {
    const mutationOptions: UseMutationOptions<BasketSetReasonResponse, BasketSetReasonError, Options<BasketSetReasonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketSetReason({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removes a product from the basket.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketRemoveItemsMutation = (options?: Partial<Options<BasketRemoveItemsData>>): UseMutationOptions<BasketRemoveItemsResponse, BasketRemoveItemsError, Options<BasketRemoveItemsData>> => {
    const mutationOptions: UseMutationOptions<BasketRemoveItemsResponse, BasketRemoveItemsError, Options<BasketRemoveItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketRemoveItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const basketGetFormAnswersQueryKey = (options: Options<BasketGetFormAnswersData>) => createQueryKey('basketGetFormAnswers', options);

/**
 * Gets form answers for a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketGetFormAnswersOptions = (options: Options<BasketGetFormAnswersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await BasketService.basketGetFormAnswers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: basketGetFormAnswersQueryKey(options)
    });
};

/**
 * Submits or updates form answers for a basket product.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketSetFormAnswersMutation = (options?: Partial<Options<BasketSetFormAnswersData>>): UseMutationOptions<BasketSetFormAnswersResponse, BasketSetFormAnswersError, Options<BasketSetFormAnswersData>> => {
    const mutationOptions: UseMutationOptions<BasketSetFormAnswersResponse, BasketSetFormAnswersError, Options<BasketSetFormAnswersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketSetFormAnswers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validates and prepares the basket for commit. Same as CreateCommit.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketPreCommitMutation = (options?: Partial<Options<BasketPreCommitData>>): UseMutationOptions<BasketPreCommitResponse, BasketPreCommitError, Options<BasketPreCommitData>> => {
    const mutationOptions: UseMutationOptions<BasketPreCommitResponse, BasketPreCommitError, Options<BasketPreCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketPreCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancels and fails an in-progress commit job.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketDeleteCommitMutation = (options?: Partial<Options<BasketDeleteCommitData>>): UseMutationOptions<BasketDeleteCommitResponse, BasketDeleteCommitError, Options<BasketDeleteCommitData>> => {
    const mutationOptions: UseMutationOptions<BasketDeleteCommitResponse, BasketDeleteCommitError, Options<BasketDeleteCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketDeleteCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const basketCommitStatusQueryCommitStatusActionQueryKey = (options: Options<BasketCommitStatusQueryCommitStatusActionData>) => createQueryKey('basketCommitStatusQueryCommitStatusAction', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketCommitStatusController
 */
export const basketCommitStatusQueryCommitStatusActionOptions = (options: Options<BasketCommitStatusQueryCommitStatusActionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await BasketCommitStatusService.basketCommitStatusQueryCommitStatusAction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: basketCommitStatusQueryCommitStatusActionQueryKey(options)
    });
};

/**
 * Continues a previously started commit job.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketContinueCommitMutation = (options?: Partial<Options<BasketContinueCommitData>>): UseMutationOptions<BasketContinueCommitResponse, BasketContinueCommitError, Options<BasketContinueCommitData>> => {
    const mutationOptions: UseMutationOptions<BasketContinueCommitResponse, BasketContinueCommitError, Options<BasketContinueCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketContinueCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Creates a commit job for the basket, validates, and attempts to finalize.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketCreateCommitMutation = (options?: Partial<Options<BasketCreateCommitData>>): UseMutationOptions<BasketCreateCommitResponse, BasketCreateCommitError, Options<BasketCreateCommitData>> => {
    const mutationOptions: UseMutationOptions<BasketCreateCommitResponse, BasketCreateCommitError, Options<BasketCreateCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketCreateCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Creates a commit job for the basket. Legacy version returning only the job id.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.BasketController
 */
export const basketCreateCommitOldMutation = (options?: Partial<Options<BasketCreateCommitOldData>>): UseMutationOptions<BasketCreateCommitOldResponse, BasketCreateCommitOldError, Options<BasketCreateCommitOldData>> => {
    const mutationOptions: UseMutationOptions<BasketCreateCommitOldResponse, BasketCreateCommitOldError, Options<BasketCreateCommitOldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BasketService.basketCreateCommitOld({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.CareCompanionController
 */
export const careCompanionCreateSessionMutation = (options?: Partial<Options<CareCompanionCreateSessionData>>): UseMutationOptions<CareCompanionCreateSessionResponse, CareCompanionCreateSessionError, Options<CareCompanionCreateSessionData>> => {
    const mutationOptions: UseMutationOptions<CareCompanionCreateSessionResponse, CareCompanionCreateSessionError, Options<CareCompanionCreateSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await CareCompanionService.careCompanionCreateSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.CareCompanionController
 */
export const careCompanionEndSessionMutation = (options?: Partial<Options<CareCompanionEndSessionData>>): UseMutationOptions<CareCompanionEndSessionResponse, CareCompanionEndSessionError, Options<CareCompanionEndSessionData>> => {
    const mutationOptions: UseMutationOptions<CareCompanionEndSessionResponse, CareCompanionEndSessionError, Options<CareCompanionEndSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await CareCompanionService.careCompanionEndSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const privacyPolicyWebInfoQueryKey = (options: Options<PrivacyPolicyWebInfoData>) => createQueryKey('privacyPolicyWebInfo', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
 */
export const privacyPolicyWebInfoOptions = (options: Options<PrivacyPolicyWebInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppService.privacyPolicyWebInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: privacyPolicyWebInfoQueryKey(options)
    });
};

export const clientAppPointToPrivacyPolicyQueryKey = (options: Options<ClientAppPointToPrivacyPolicyData>) => createQueryKey('clientAppPointToPrivacyPolicy', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
 */
export const clientAppPointToPrivacyPolicyOptions = (options: Options<ClientAppPointToPrivacyPolicyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppService.clientAppPointToPrivacyPolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppPointToPrivacyPolicyQueryKey(options)
    });
};

export const clientAppPointToTermsOfServiceQueryKey = (options: Options<ClientAppPointToTermsOfServiceData>) => createQueryKey('clientAppPointToTermsOfService', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
 */
export const clientAppPointToTermsOfServiceOptions = (options: Options<ClientAppPointToTermsOfServiceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppService.clientAppPointToTermsOfService({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppPointToTermsOfServiceQueryKey(options)
    });
};

export const clientAppGetConfigQueryKey = (options: Options<ClientAppGetConfigData>) => createQueryKey('clientAppGetConfig', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppController
 */
export const clientAppGetConfigOptions = (options: Options<ClientAppGetConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppService.clientAppGetConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppGetConfigQueryKey(options)
    });
};

export const clientAppointmentsGetUpcomingAndUnfinishedQueryKey = (options?: Options<ClientAppointmentsGetUpcomingAndUnfinishedData>) => createQueryKey('clientAppointmentsGetUpcomingAndUnfinished', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsGetUpcomingAndUnfinishedOptions = (options?: Options<ClientAppointmentsGetUpcomingAndUnfinishedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsGetUpcomingAndUnfinished({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppointmentsGetUpcomingAndUnfinishedQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsCancelMutation = (options?: Partial<Options<ClientAppointmentsCancelData>>): UseMutationOptions<ClientAppointmentsCancelResponse, ClientAppointmentsCancelError, Options<ClientAppointmentsCancelData>> => {
    const mutationOptions: UseMutationOptions<ClientAppointmentsCancelResponse, ClientAppointmentsCancelError, Options<ClientAppointmentsCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientAppointmentsGetQueryKey = (options: Options<ClientAppointmentsGetData>) => createQueryKey('clientAppointmentsGet', options);

/**
 * Used by booking participants (clients, outsiders or resources) to retrieve appointment details.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsGetOptions = (options: Options<ClientAppointmentsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppointmentsGetQueryKey(options)
    });
};

export const clientAppointmentsGetCallStatusQueryKey = (options: Options<ClientAppointmentsGetCallStatusData>) => createQueryKey('clientAppointmentsGetCallStatus', options);

/**
 * Used by booking participants (clients, outsiders or resources) to retrieve information about a call.
 * This endpoint is polled every X seconds while on the evaluation and lobby views to determine when a
 * toast notification should be shown, how many participants are in the call and whether the user
 * should be able to reconnect or not.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsGetCallStatusOptions = (options: Options<ClientAppointmentsGetCallStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsGetCallStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAppointmentsGetCallStatusQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsDeclineMutation = (options?: Partial<Options<ClientAppointmentsDeclineData>>): UseMutationOptions<ClientAppointmentsDeclineResponse, ClientAppointmentsDeclineError, Options<ClientAppointmentsDeclineData>> => {
    const mutationOptions: UseMutationOptions<ClientAppointmentsDeclineResponse, ClientAppointmentsDeclineError, Options<ClientAppointmentsDeclineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsDecline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Used by clients to update the list of legal guardians invited to an existing booking.
 * The provided list represents the desired set of invited legal guardians; guardians that
 * are currently invited but are not in the list will be uninvited, and guardians in the list
 * that are not currently invited will be added as participants.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsUpdateLegalGuardiansMutation = (options?: Partial<Options<ClientAppointmentsUpdateLegalGuardiansData>>): UseMutationOptions<ClientAppointmentsUpdateLegalGuardiansResponse, ClientAppointmentsUpdateLegalGuardiansError, Options<ClientAppointmentsUpdateLegalGuardiansData>> => {
    const mutationOptions: UseMutationOptions<ClientAppointmentsUpdateLegalGuardiansResponse, ClientAppointmentsUpdateLegalGuardiansError, Options<ClientAppointmentsUpdateLegalGuardiansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsUpdateLegalGuardians({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Used by booking participants (clients, outsiders or resources) to post files during a video call.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientAppointmentsController
 */
export const clientAppointmentsAddFileMutation = (options?: Partial<Options<ClientAppointmentsAddFileData>>): UseMutationOptions<ClientAppointmentsAddFileResponse, ClientAppointmentsAddFileError, Options<ClientAppointmentsAddFileData>> => {
    const mutationOptions: UseMutationOptions<ClientAppointmentsAddFileResponse, ClientAppointmentsAddFileError, Options<ClientAppointmentsAddFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientAppointmentsService.clientAppointmentsAddFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientAuthMethodsGetAuthMethodsQueryKey = (options: Options<ClientAuthMethodsGetAuthMethodsData>) => createQueryKey('clientAuthMethodsGetAuthMethods', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientAuthMethodsController
 */
export const clientAuthMethodsGetAuthMethodsOptions = (options: Options<ClientAuthMethodsGetAuthMethodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientAuthMethodsService.clientAuthMethodsGetAuthMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientAuthMethodsGetAuthMethodsQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
 */
export const clientBookableTimeLocksCreateLockMutation = (options?: Partial<Options<ClientBookableTimeLocksCreateLockData>>): UseMutationOptions<ClientBookableTimeLocksCreateLockResponse, ClientBookableTimeLocksCreateLockError, Options<ClientBookableTimeLocksCreateLockData>> => {
    const mutationOptions: UseMutationOptions<ClientBookableTimeLocksCreateLockResponse, ClientBookableTimeLocksCreateLockError, Options<ClientBookableTimeLocksCreateLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientBookableTimeLocksService.clientBookableTimeLocksCreateLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
 */
export const clientBookableTimeLocksReleaseLockMutation = (options?: Partial<Options<ClientBookableTimeLocksReleaseLockData>>): UseMutationOptions<ClientBookableTimeLocksReleaseLockResponse, ClientBookableTimeLocksReleaseLockError, Options<ClientBookableTimeLocksReleaseLockData>> => {
    const mutationOptions: UseMutationOptions<ClientBookableTimeLocksReleaseLockResponse, ClientBookableTimeLocksReleaseLockError, Options<ClientBookableTimeLocksReleaseLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientBookableTimeLocksService.clientBookableTimeLocksReleaseLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientBookableTimeLocksController
 */
export const clientBookableTimeLocksExtendLockMutation = (options?: Partial<Options<ClientBookableTimeLocksExtendLockData>>): UseMutationOptions<ClientBookableTimeLocksExtendLockResponse, ClientBookableTimeLocksExtendLockError, Options<ClientBookableTimeLocksExtendLockData>> => {
    const mutationOptions: UseMutationOptions<ClientBookableTimeLocksExtendLockResponse, ClientBookableTimeLocksExtendLockError, Options<ClientBookableTimeLocksExtendLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientBookableTimeLocksService.clientBookableTimeLocksExtendLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientCasesListUpdatesQueryKey = (options?: Options<ClientCasesListUpdatesData>) => createQueryKey('clientCasesListUpdates', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
 */
export const clientCasesListUpdatesOptions = (options?: Options<ClientCasesListUpdatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientCasesService.clientCasesListUpdates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientCasesListUpdatesQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
 */
export const clientCasesMarkNewAppointmentSeenMutation = (options?: Partial<Options<ClientCasesMarkNewAppointmentSeenData>>): UseMutationOptions<ClientCasesMarkNewAppointmentSeenResponse, ClientCasesMarkNewAppointmentSeenError, Options<ClientCasesMarkNewAppointmentSeenData>> => {
    const mutationOptions: UseMutationOptions<ClientCasesMarkNewAppointmentSeenResponse, ClientCasesMarkNewAppointmentSeenError, Options<ClientCasesMarkNewAppointmentSeenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientCasesService.clientCasesMarkNewAppointmentSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientCasesPrioritizedV2QueryKey = (options?: Options<ClientCasesPrioritizedV2Data>) => createQueryKey('clientCasesPrioritizedV2', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Cases.ClientCasesController
 */
export const clientCasesPrioritizedV2Options = (options?: Options<ClientCasesPrioritizedV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientCasesService.clientCasesPrioritizedV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientCasesPrioritizedV2QueryKey(options)
    });
};

export const clientConditionsListQueryKey = (options: Options<ClientConditionsListData>) => createQueryKey('clientConditionsList', options);

/**
 * Obsolete Drop in replacement by ClientReceptionConditionsController
 * Defined in VisibaCare.Api.Client.v2.Controllers.ClientConditionsController
 * @deprecated
 */
export const clientConditionsListOptions = (options: Options<ClientConditionsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientConditionsService.clientConditionsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientConditionsListQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const clientDropInEnqueueMutation = (options?: Partial<Options<ClientDropInEnqueueData>>): UseMutationOptions<ClientDropInEnqueueResponse, ClientDropInEnqueueError, Options<ClientDropInEnqueueData>> => {
    const mutationOptions: UseMutationOptions<ClientDropInEnqueueResponse, ClientDropInEnqueueError, Options<ClientDropInEnqueueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientDropInService.clientDropInEnqueue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const clientDropInCancelMutation = (options?: Partial<Options<ClientDropInCancelData>>): UseMutationOptions<ClientDropInCancelResponse, ClientDropInCancelError, Options<ClientDropInCancelData>> => {
    const mutationOptions: UseMutationOptions<ClientDropInCancelResponse, ClientDropInCancelError, Options<ClientDropInCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientDropInService.clientDropInCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientDropInGetTicketQueryKey = (options: Options<ClientDropInGetTicketData>) => createQueryKey('clientDropInGetTicket', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const clientDropInGetTicketOptions = (options: Options<ClientDropInGetTicketData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.clientDropInGetTicket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientDropInGetTicketQueryKey(options)
    });
};

export const getActiveTicketQueryKey = (options?: Options<GetActiveTicketData>) => createQueryKey('getActiveTicket', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const getActiveTicketOptions = (options?: Options<GetActiveTicketData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.getActiveTicket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActiveTicketQueryKey(options)
    });
};

export const getActiveTicketForRoomQueryKey = (options: Options<GetActiveTicketForRoomData>) => createQueryKey('getActiveTicketForRoom', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const getActiveTicketForRoomOptions = (options: Options<GetActiveTicketForRoomData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.getActiveTicketForRoom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActiveTicketForRoomQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientDropInController
 */
export const clientDropInUploadMutation = (options?: Partial<Options<ClientDropInUploadData>>): UseMutationOptions<ClientDropInUploadResponse, ClientDropInUploadError, Options<ClientDropInUploadData>> => {
    const mutationOptions: UseMutationOptions<ClientDropInUploadResponse, ClientDropInUploadError, Options<ClientDropInUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientDropInService.clientDropInUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientDropInListQueryKey = (options: Options<ClientDropInListData>) => createQueryKey('clientDropInList', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
 */
export const clientDropInListOptions = (options: Options<ClientDropInListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.clientDropInList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientDropInListQueryKey(options)
    });
};

export const clientDropInGetQueryKey = (options: Options<ClientDropInGetData>) => createQueryKey('clientDropInGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
 */
export const clientDropInGetOptions = (options: Options<ClientDropInGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.clientDropInGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientDropInGetQueryKey(options)
    });
};

export const clientDropInGetByUrlAliasQueryKey = (options: Options<ClientDropInGetByUrlAliasData>) => createQueryKey('clientDropInGetByUrlAlias', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientDropInController
 */
export const clientDropInGetByUrlAliasOptions = (options: Options<ClientDropInGetByUrlAliasData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientDropInService.clientDropInGetByUrlAlias({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientDropInGetByUrlAliasQueryKey(options)
    });
};

export const clientFormsListQueryKey = (options: Options<ClientFormsListData>) => createQueryKey('clientFormsList', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
 */
export const clientFormsListOptions = (options: Options<ClientFormsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientFormsService.clientFormsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientFormsListQueryKey(options)
    });
};

export const clientFormsGetFormGraphQueryKey = (options: Options<ClientFormsGetFormGraphData>) => createQueryKey('clientFormsGetFormGraph', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
 */
export const clientFormsGetFormGraphOptions = (options: Options<ClientFormsGetFormGraphData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientFormsService.clientFormsGetFormGraph({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientFormsGetFormGraphQueryKey(options)
    });
};

export const clientFormsGetRespondantQueryKey = (options: Options<ClientFormsGetRespondantData>) => createQueryKey('clientFormsGetRespondant', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
 */
export const clientFormsGetRespondantOptions = (options: Options<ClientFormsGetRespondantData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientFormsService.clientFormsGetRespondant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientFormsGetRespondantQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
 */
export const clientFormsSaveAnswersMutation = (options?: Partial<Options<ClientFormsSaveAnswersData>>): UseMutationOptions<ClientFormsSaveAnswersResponse, ClientFormsSaveAnswersError, Options<ClientFormsSaveAnswersData>> => {
    const mutationOptions: UseMutationOptions<ClientFormsSaveAnswersResponse, ClientFormsSaveAnswersError, Options<ClientFormsSaveAnswersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientFormsService.clientFormsSaveAnswers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientFormsController
 */
export const clientFormsSetRespondantCompleteMutation = (options?: Partial<Options<ClientFormsSetRespondantCompleteData>>): UseMutationOptions<ClientFormsSetRespondantCompleteResponse, ClientFormsSetRespondantCompleteError, Options<ClientFormsSetRespondantCompleteData>> => {
    const mutationOptions: UseMutationOptions<ClientFormsSetRespondantCompleteResponse, ClientFormsSetRespondantCompleteError, Options<ClientFormsSetRespondantCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientFormsService.clientFormsSetRespondantComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientGuiComponentsListQueryKey = (options: Options<ClientGuiComponentsListData>) => createQueryKey('clientGuiComponentsList', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientGuiComponentsController
 */
export const clientGuiComponentsListOptions = (options: Options<ClientGuiComponentsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientGuiComponentsService.clientGuiComponentsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientGuiComponentsListQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityDeleteMutation = (options?: Partial<Options<ClientIdentityDeleteData>>): UseMutationOptions<ClientIdentityDeleteResponse, ClientIdentityDeleteError, Options<ClientIdentityDeleteData>> => {
    const mutationOptions: UseMutationOptions<ClientIdentityDeleteResponse, ClientIdentityDeleteError, Options<ClientIdentityDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientIdentityService.clientIdentityDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientIdentityGetQueryKey = (options?: Options<ClientIdentityGetData>) => createQueryKey('clientIdentityGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityGetOptions = (options?: Options<ClientIdentityGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientIdentityService.clientIdentityGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIdentityGetQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityUpdateMutation = (options?: Partial<Options<ClientIdentityUpdateData>>): UseMutationOptions<ClientIdentityUpdateResponse, ClientIdentityUpdateError, Options<ClientIdentityUpdateData>> => {
    const mutationOptions: UseMutationOptions<ClientIdentityUpdateResponse, ClientIdentityUpdateError, Options<ClientIdentityUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientIdentityService.clientIdentityUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientIdentityInviteablePersonsQueryKey = (options?: Options<ClientIdentityInviteablePersonsData>) => createQueryKey('clientIdentityInviteablePersons', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityInviteablePersonsOptions = (options?: Options<ClientIdentityInviteablePersonsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientIdentityService.clientIdentityInviteablePersons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIdentityInviteablePersonsQueryKey(options)
    });
};

export const clientIdentityCanDeleteQueryKey = (options?: Options<ClientIdentityCanDeleteData>) => createQueryKey('clientIdentityCanDelete', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityCanDeleteOptions = (options?: Options<ClientIdentityCanDeleteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientIdentityService.clientIdentityCanDelete({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIdentityCanDeleteQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentitySignOutMutation = (options?: Partial<Options<ClientIdentitySignOutData>>): UseMutationOptions<ClientIdentitySignOutResponse, ClientIdentitySignOutError, Options<ClientIdentitySignOutData>> => {
    const mutationOptions: UseMutationOptions<ClientIdentitySignOutResponse, ClientIdentitySignOutError, Options<ClientIdentitySignOutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientIdentityService.clientIdentitySignOut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientIdentityIsAliveQueryKey = (options?: Options<ClientIdentityIsAliveData>) => createQueryKey('clientIdentityIsAlive', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityIsAliveOptions = (options?: Options<ClientIdentityIsAliveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientIdentityService.clientIdentityIsAlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIdentityIsAliveQueryKey(options)
    });
};

export const clientIdentityIsAliveOutsiderQueryKey = (options?: Options<ClientIdentityIsAliveOutsiderData>) => createQueryKey('clientIdentityIsAliveOutsider', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientIdentityController
 */
export const clientIdentityIsAliveOutsiderOptions = (options?: Options<ClientIdentityIsAliveOutsiderData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientIdentityService.clientIdentityIsAliveOutsider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIdentityIsAliveOutsiderQueryKey(options)
    });
};

export const clientMessagingListQueryKey = (options?: Options<ClientMessagingListData>) => createQueryKey('clientMessagingList', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
 */
export const clientMessagingListOptions = (options?: Options<ClientMessagingListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientMessagingService.clientMessagingList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientMessagingListQueryKey(options)
    });
};

export const clientMessagingGetQueryKey = (options: Options<ClientMessagingGetData>) => createQueryKey('clientMessagingGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
 */
export const clientMessagingGetOptions = (options: Options<ClientMessagingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientMessagingService.clientMessagingGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientMessagingGetQueryKey(options)
    });
};

export const clientMessagingGetCaseQueryKey = (options: Options<ClientMessagingGetCaseData>) => createQueryKey('clientMessagingGetCase', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingController
 */
export const clientMessagingGetCaseOptions = (options: Options<ClientMessagingGetCaseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientMessagingService.clientMessagingGetCase({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientMessagingGetCaseQueryKey(options)
    });
};

/**
 * Used by clients to update the list of legal guardians invited to an existing messaging
 * conversation. The provided list represents the desired set of invited legal guardians;
 * guardians that are currently invited but are not in the list will be uninvited, and guardians
 * in the list that are not currently invited will be added as participants.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientMessagingController
 */
export const clientMessagingUpdateLegalGuardiansMutation = (options?: Partial<Options<ClientMessagingUpdateLegalGuardiansData>>): UseMutationOptions<ClientMessagingUpdateLegalGuardiansResponse, ClientMessagingUpdateLegalGuardiansError, Options<ClientMessagingUpdateLegalGuardiansData>> => {
    const mutationOptions: UseMutationOptions<ClientMessagingUpdateLegalGuardiansResponse, ClientMessagingUpdateLegalGuardiansError, Options<ClientMessagingUpdateLegalGuardiansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientMessagingService.clientMessagingUpdateLegalGuardians({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientMessagingCompletionController
 */
export const clientMessagingCompletionCompleteCaseMutation = (options?: Partial<Options<ClientMessagingCompletionCompleteCaseData>>): UseMutationOptions<ClientMessagingCompletionCompleteCaseResponse, ClientMessagingCompletionCompleteCaseError, Options<ClientMessagingCompletionCompleteCaseData>> => {
    const mutationOptions: UseMutationOptions<ClientMessagingCompletionCompleteCaseResponse, ClientMessagingCompletionCompleteCaseError, Options<ClientMessagingCompletionCompleteCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientMessagingCompletionService.clientMessagingCompletionCompleteCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
 */
export const clientNotificationTargetsDeleteStandardTargetMutation = (options?: Partial<Options<ClientNotificationTargetsDeleteStandardTargetData>>): UseMutationOptions<ClientNotificationTargetsDeleteStandardTargetResponse, ClientNotificationTargetsDeleteStandardTargetError, Options<ClientNotificationTargetsDeleteStandardTargetData>> => {
    const mutationOptions: UseMutationOptions<ClientNotificationTargetsDeleteStandardTargetResponse, ClientNotificationTargetsDeleteStandardTargetError, Options<ClientNotificationTargetsDeleteStandardTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientNotificationTargetsService.clientNotificationTargetsDeleteStandardTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
 */
export const clientNotificationTargetsSetStandardTargetMutation = (options?: Partial<Options<ClientNotificationTargetsSetStandardTargetData>>): UseMutationOptions<ClientNotificationTargetsSetStandardTargetResponse, ClientNotificationTargetsSetStandardTargetError, Options<ClientNotificationTargetsSetStandardTargetData>> => {
    const mutationOptions: UseMutationOptions<ClientNotificationTargetsSetStandardTargetResponse, ClientNotificationTargetsSetStandardTargetError, Options<ClientNotificationTargetsSetStandardTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientNotificationTargetsService.clientNotificationTargetsSetStandardTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
 */
export const clientNotificationTargetsDeleteVoipTargetMutation = (options?: Partial<Options<ClientNotificationTargetsDeleteVoipTargetData>>): UseMutationOptions<ClientNotificationTargetsDeleteVoipTargetResponse, ClientNotificationTargetsDeleteVoipTargetError, Options<ClientNotificationTargetsDeleteVoipTargetData>> => {
    const mutationOptions: UseMutationOptions<ClientNotificationTargetsDeleteVoipTargetResponse, ClientNotificationTargetsDeleteVoipTargetError, Options<ClientNotificationTargetsDeleteVoipTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientNotificationTargetsService.clientNotificationTargetsDeleteVoipTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientNotificationTargetsController
 */
export const clientNotificationTargetsSetVoipTargetMutation = (options?: Partial<Options<ClientNotificationTargetsSetVoipTargetData>>): UseMutationOptions<ClientNotificationTargetsSetVoipTargetResponse, ClientNotificationTargetsSetVoipTargetError, Options<ClientNotificationTargetsSetVoipTargetData>> => {
    const mutationOptions: UseMutationOptions<ClientNotificationTargetsSetVoipTargetResponse, ClientNotificationTargetsSetVoipTargetError, Options<ClientNotificationTargetsSetVoipTargetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientNotificationTargetsService.clientNotificationTargetsSetVoipTarget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientPaymentsPaymentServicesQueryKey = (options: Options<ClientPaymentsPaymentServicesData>) => createQueryKey('clientPaymentsPaymentServices', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientPaymentsController
 */
export const clientPaymentsPaymentServicesOptions = (options: Options<ClientPaymentsPaymentServicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientPaymentsService.clientPaymentsPaymentServices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientPaymentsPaymentServicesQueryKey(options)
    });
};

export const clientReceptionConditionsListQueryKey = (options: Options<ClientReceptionConditionsListData>) => createQueryKey('clientReceptionConditionsList', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.ClientReceptionConditionsController
 */
export const clientReceptionConditionsListOptions = (options: Options<ClientReceptionConditionsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientReceptionConditionsService.clientReceptionConditionsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientReceptionConditionsListQueryKey(options)
    });
};

export const clientRegistrationGetRegistrationQueryKey = (options: Options<ClientRegistrationGetRegistrationData>) => createQueryKey('clientRegistrationGetRegistration', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientRegistrationController
 */
export const clientRegistrationGetRegistrationOptions = (options: Options<ClientRegistrationGetRegistrationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientRegistrationService.clientRegistrationGetRegistration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientRegistrationGetRegistrationQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientRegistrationController
 */
export const clientRegistrationCompleteRegistrationMutation = (options?: Partial<Options<ClientRegistrationCompleteRegistrationData>>): UseMutationOptions<ClientRegistrationCompleteRegistrationResponse, ClientRegistrationCompleteRegistrationError, Options<ClientRegistrationCompleteRegistrationData>> => {
    const mutationOptions: UseMutationOptions<ClientRegistrationCompleteRegistrationResponse, ClientRegistrationCompleteRegistrationError, Options<ClientRegistrationCompleteRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientRegistrationService.clientRegistrationCompleteRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
 */
export const clientSmsStartAuthMutation = (options?: Partial<Options<ClientSmsStartAuthData>>): UseMutationOptions<ClientSmsStartAuthResponse, ClientSmsStartAuthError, Options<ClientSmsStartAuthData>> => {
    const mutationOptions: UseMutationOptions<ClientSmsStartAuthResponse, ClientSmsStartAuthError, Options<ClientSmsStartAuthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientSmsService.clientSmsStartAuth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
 */
export const clientSmsStartAuthWithCallTicketMutation = (options?: Partial<Options<ClientSmsStartAuthWithCallTicketData>>): UseMutationOptions<ClientSmsStartAuthWithCallTicketResponse, ClientSmsStartAuthWithCallTicketError, Options<ClientSmsStartAuthWithCallTicketData>> => {
    const mutationOptions: UseMutationOptions<ClientSmsStartAuthWithCallTicketResponse, ClientSmsStartAuthWithCallTicketError, Options<ClientSmsStartAuthWithCallTicketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientSmsService.clientSmsStartAuthWithCallTicket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
 */
export const clientSmsReSendCodeMutation = (options?: Partial<Options<ClientSmsReSendCodeData>>): UseMutationOptions<ClientSmsReSendCodeResponse, ClientSmsReSendCodeError, Options<ClientSmsReSendCodeData>> => {
    const mutationOptions: UseMutationOptions<ClientSmsReSendCodeResponse, ClientSmsReSendCodeError, Options<ClientSmsReSendCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientSmsService.clientSmsReSendCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
 */
export const clientSmsConfirmCodeMutation = (options?: Partial<Options<ClientSmsConfirmCodeData>>): UseMutationOptions<ClientSmsConfirmCodeResponse, ClientSmsConfirmCodeError, Options<ClientSmsConfirmCodeData>> => {
    const mutationOptions: UseMutationOptions<ClientSmsConfirmCodeResponse, ClientSmsConfirmCodeError, Options<ClientSmsConfirmCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientSmsService.clientSmsConfirmCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientSmsPreRegisteredNumberQueryKey = (options: Options<ClientSmsPreRegisteredNumberData>) => createQueryKey('clientSmsPreRegisteredNumber', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.Auth.ClientSmsController
 */
export const clientSmsPreRegisteredNumberOptions = (options: Options<ClientSmsPreRegisteredNumberData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientSmsService.clientSmsPreRegisteredNumber({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientSmsPreRegisteredNumberQueryKey(options)
    });
};

export const clientSurveysGetSurveyQueryKey = (options: Options<ClientSurveysGetSurveyData>) => createQueryKey('clientSurveysGetSurvey', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientSurveysController
 */
export const clientSurveysGetSurveyOptions = (options: Options<ClientSurveysGetSurveyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientSurveysService.clientSurveysGetSurvey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientSurveysGetSurveyQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientSurveysController
 */
export const clientSurveysAnswerSurveyMutation = (options?: Partial<Options<ClientSurveysAnswerSurveyData>>): UseMutationOptions<ClientSurveysAnswerSurveyResponse, ClientSurveysAnswerSurveyError, Options<ClientSurveysAnswerSurveyData>> => {
    const mutationOptions: UseMutationOptions<ClientSurveysAnswerSurveyResponse, ClientSurveysAnswerSurveyError, Options<ClientSurveysAnswerSurveyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientSurveysService.clientSurveysAnswerSurvey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientThemeGetPublicThemeQueryKey = (options: Options<ClientThemeGetPublicThemeData>) => createQueryKey('clientThemeGetPublicTheme', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientThemeController
 */
export const clientThemeGetPublicThemeOptions = (options: Options<ClientThemeGetPublicThemeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientThemeService.clientThemeGetPublicTheme({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientThemeGetPublicThemeQueryKey(options)
    });
};

export const clientTimeslotsTimeslotsQueryKey = (options: Options<ClientTimeslotsTimeslotsData>) => createQueryKey('clientTimeslotsTimeslots', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsTimeslotsOptions = (options: Options<ClientTimeslotsTimeslotsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsTimeslots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsTimeslotsQueryKey(options)
    });
};

export const clientTimeslotsTimeslotQueryKey = (options: Options<ClientTimeslotsTimeslotData>) => createQueryKey('clientTimeslotsTimeslot', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsTimeslotOptions = (options: Options<ClientTimeslotsTimeslotData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsTimeslot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsTimeslotQueryKey(options)
    });
};

export const clientTimeslotsSearchLocalityAvailabilityQueryKey = (options: Options<ClientTimeslotsSearchLocalityAvailabilityData>) => createQueryKey('clientTimeslotsSearchLocalityAvailability', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsSearchLocalityAvailabilityOptions = (options: Options<ClientTimeslotsSearchLocalityAvailabilityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsSearchLocalityAvailability({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsSearchLocalityAvailabilityQueryKey(options)
    });
};

export const clientTimeslotsGetAvailabilityCountsQueryKey = (options: Options<ClientTimeslotsGetAvailabilityCountsData>) => createQueryKey('clientTimeslotsGetAvailabilityCounts', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsGetAvailabilityCountsOptions = (options: Options<ClientTimeslotsGetAvailabilityCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsGetAvailabilityCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsGetAvailabilityCountsQueryKey(options)
    });
};

export const clientTimeslotsGetSearchCapabilitiesQueryKey = (options: Options<ClientTimeslotsGetSearchCapabilitiesData>) => createQueryKey('clientTimeslotsGetSearchCapabilities', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsGetSearchCapabilitiesOptions = (options: Options<ClientTimeslotsGetSearchCapabilitiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsGetSearchCapabilities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsGetSearchCapabilitiesQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsBookSlotMutation = (options?: Partial<Options<ClientTimeslotsBookSlotData>>): UseMutationOptions<ClientTimeslotsBookSlotResponse, ClientTimeslotsBookSlotError, Options<ClientTimeslotsBookSlotData>> => {
    const mutationOptions: UseMutationOptions<ClientTimeslotsBookSlotResponse, ClientTimeslotsBookSlotError, Options<ClientTimeslotsBookSlotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsBookSlot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientTimeslotsGetRescheduleTimeslotsQueryKey = (options: Options<ClientTimeslotsGetRescheduleTimeslotsData>) => createQueryKey('clientTimeslotsGetRescheduleTimeslots', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsGetRescheduleTimeslotsOptions = (options: Options<ClientTimeslotsGetRescheduleTimeslotsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsGetRescheduleTimeslots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsGetRescheduleTimeslotsQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsRebookWithNewTimeslotMutation = (options?: Partial<Options<ClientTimeslotsRebookWithNewTimeslotData>>): UseMutationOptions<ClientTimeslotsRebookWithNewTimeslotResponse, ClientTimeslotsRebookWithNewTimeslotError, Options<ClientTimeslotsRebookWithNewTimeslotData>> => {
    const mutationOptions: UseMutationOptions<ClientTimeslotsRebookWithNewTimeslotResponse, ClientTimeslotsRebookWithNewTimeslotError, Options<ClientTimeslotsRebookWithNewTimeslotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsRebookWithNewTimeslot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientTimeslotsGetRescheduleAvailabilityCountsQueryKey = (options: Options<ClientTimeslotsGetRescheduleAvailabilityCountsData>) => createQueryKey('clientTimeslotsGetRescheduleAvailabilityCounts', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientTimeslotsController
 */
export const clientTimeslotsGetRescheduleAvailabilityCountsOptions = (options: Options<ClientTimeslotsGetRescheduleAvailabilityCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientTimeslotsService.clientTimeslotsGetRescheduleAvailabilityCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientTimeslotsGetRescheduleAvailabilityCountsQueryKey(options)
    });
};

export const clientUnitsListUnitsQueryKey = (options: Options<ClientUnitsListUnitsData>) => createQueryKey('clientUnitsListUnits', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsListUnitsOptions = (options: Options<ClientUnitsListUnitsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsListUnits({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsListUnitsQueryKey(options)
    });
};

export const clientUnitsGetQueryKey = (options: Options<ClientUnitsGetData>) => createQueryKey('clientUnitsGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsGetOptions = (options: Options<ClientUnitsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsGetQueryKey(options)
    });
};

export const clientUnitsGetThemeQueryKey = (options: Options<ClientUnitsGetThemeData>) => createQueryKey('clientUnitsGetTheme', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsGetThemeOptions = (options: Options<ClientUnitsGetThemeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsGetTheme({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsGetThemeQueryKey(options)
    });
};

export const clientUnitsGetAboutQueryKey = (options: Options<ClientUnitsGetAboutData>) => createQueryKey('clientUnitsGetAbout', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsGetAboutOptions = (options: Options<ClientUnitsGetAboutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsGetAbout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsGetAboutQueryKey(options)
    });
};

export const clientUnitsGetTextsQueryKey = (options: Options<ClientUnitsGetTextsData>) => createQueryKey('clientUnitsGetTexts', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsGetTextsOptions = (options: Options<ClientUnitsGetTextsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsGetTexts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsGetTextsQueryKey(options)
    });
};

export const clientUnitsGetIdentifierConflictsQueryKey = (options: Options<ClientUnitsGetIdentifierConflictsData>) => createQueryKey('clientUnitsGetIdentifierConflicts', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.ClientUnitsController
 */
export const clientUnitsGetIdentifierConflictsOptions = (options: Options<ClientUnitsGetIdentifierConflictsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUnitsService.clientUnitsGetIdentifierConflicts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUnitsGetIdentifierConflictsQueryKey(options)
    });
};

export const clientUsageAgreementsGetDocumentsQueryKey = (options: Options<ClientUsageAgreementsGetDocumentsData>) => createQueryKey('clientUsageAgreementsGetDocuments', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientUsageAgreementsController
 */
export const clientUsageAgreementsGetDocumentsOptions = (options: Options<ClientUsageAgreementsGetDocumentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ClientUsageAgreementsService.clientUsageAgreementsGetDocuments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientUsageAgreementsGetDocumentsQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ClientUsageAgreementsController
 */
export const clientUsageAgreementsAgreeToDocumentMutation = (options?: Partial<Options<ClientUsageAgreementsAgreeToDocumentData>>): UseMutationOptions<ClientUsageAgreementsAgreeToDocumentResponse, ClientUsageAgreementsAgreeToDocumentError, Options<ClientUsageAgreementsAgreeToDocumentData>> => {
    const mutationOptions: UseMutationOptions<ClientUsageAgreementsAgreeToDocumentResponse, ClientUsageAgreementsAgreeToDocumentError, Options<ClientUsageAgreementsAgreeToDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClientUsageAgreementsService.clientUsageAgreementsAgreeToDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const currencyGetQueryKey = (options: Options<CurrencyGetData>) => createQueryKey('currencyGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.CurrencyController
 */
export const currencyGetOptions = (options: Options<CurrencyGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await CurrencyService.currencyGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: currencyGetQueryKey(options)
    });
};

export const demandManagementIsMessagingOpenQueryKey = (options: Options<DemandManagementIsMessagingOpenData>) => createQueryKey('demandManagementIsMessagingOpen', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
 */
export const demandManagementIsMessagingOpenOptions = (options: Options<DemandManagementIsMessagingOpenData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DemandManagementService.demandManagementIsMessagingOpen({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: demandManagementIsMessagingOpenQueryKey(options)
    });
};

export const demandManagementIsTriageOpenQueryKey = (options: Options<DemandManagementIsTriageOpenData>) => createQueryKey('demandManagementIsTriageOpen', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
 */
export const demandManagementIsTriageOpenOptions = (options: Options<DemandManagementIsTriageOpenData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DemandManagementService.demandManagementIsTriageOpen({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: demandManagementIsTriageOpenQueryKey(options)
    });
};

export const demandManagementGetRuleSetQueryKey = (options: Options<DemandManagementGetRuleSetData>) => createQueryKey('demandManagementGetRuleSet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.DemandManagementController
 */
export const demandManagementGetRuleSetOptions = (options: Options<DemandManagementGetRuleSetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DemandManagementService.demandManagementGetRuleSet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: demandManagementGetRuleSetQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ExternalDataController
 */
export const externalDataUploadExternalDataMutation = (options?: Partial<Options<ExternalDataUploadExternalDataData>>): UseMutationOptions<ExternalDataUploadExternalDataResponse, ExternalDataUploadExternalDataError, Options<ExternalDataUploadExternalDataData>> => {
    const mutationOptions: UseMutationOptions<ExternalDataUploadExternalDataResponse, ExternalDataUploadExternalDataError, Options<ExternalDataUploadExternalDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ExternalDataService.externalDataUploadExternalData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const homeGuiComponentsListDeprecatedQueryKey = (options: Options<HomeGuiComponentsListDeprecatedData>) => createQueryKey('homeGuiComponentsListDeprecated', options);

/**
 * This endpoint is for older mobile apps. Can't introduce a new type here or they will not work.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.HomeGuiComponentsController
 */
export const homeGuiComponentsListDeprecatedOptions = (options: Options<HomeGuiComponentsListDeprecatedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await HomeGuiComponentsService.homeGuiComponentsListDeprecated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: homeGuiComponentsListDeprecatedQueryKey(options)
    });
};

export const homeGuiComponentsListQueryKey = (options: Options<HomeGuiComponentsListData>) => createQueryKey('homeGuiComponentsList', options);

/**
 * This keeps the new behaviour with ListedAtReception model. It should be called from patient old and removed when that is removed.
 * Obsolete This endpoint is for patient old. Remove whenever patient old is ditched.
 * Defined in VisibaCare.Api.Client.v2.Controllers.HomeGuiComponentsController
 * @deprecated
 */
export const homeGuiComponentsListOptions = (options: Options<HomeGuiComponentsListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await HomeGuiComponentsService.homeGuiComponentsList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: homeGuiComponentsListQueryKey(options)
    });
};

export const identityIdpSignOutIdpQueryKey = (options?: Options<IdentityIdpSignOutIdpData>) => createQueryKey('identityIdpSignOutIdp', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.IdentityIdpController
 */
export const identityIdpSignOutIdpOptions = (options?: Options<IdentityIdpSignOutIdpData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await IdentityIdpService.identityIdpSignOutIdp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: identityIdpSignOutIdpQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.IdentityIdpController
 */
export const identityIdpSignOutIdp2Mutation = (options?: Partial<Options<IdentityIdpSignOutIdp2Data>>): UseMutationOptions<unknown, DefaultError, Options<IdentityIdpSignOutIdp2Data>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<IdentityIdpSignOutIdp2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await IdentityIdpService.identityIdpSignOutIdp2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const idpAuthMethodsGetAuthMethodsQueryKey = (options: Options<IdpAuthMethodsGetAuthMethodsData>) => createQueryKey('idpAuthMethodsGetAuthMethods', options);

/**
 * List authentication methods that belongs to a licence holder.
 *  Defined in VisibaCare.Api.Client.Controllers.Auth.IdpAuthMethodsController
 */
export const idpAuthMethodsGetAuthMethodsOptions = (options: Options<IdpAuthMethodsGetAuthMethodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await IdpAuthMethodsService.idpAuthMethodsGetAuthMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: idpAuthMethodsGetAuthMethodsQueryKey(options)
    });
};

export const informationGatheringGetEligibilityQueryKey = (options?: Options<InformationGatheringGetEligibilityData>) => createQueryKey('informationGatheringGetEligibility', options);

/**
 * Checks whether the NHS-authenticated client can use the information-gathering journey.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.InformationGatheringController
 */
export const informationGatheringGetEligibilityOptions = (options?: Options<InformationGatheringGetEligibilityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await InformationGatheringService.informationGatheringGetEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: informationGatheringGetEligibilityQueryKey(options)
    });
};

/**
 * Stores a completed information-gathering submission before destination navigation starts.
 * Each request creates a new submission and returns its ID.
 */
export const informationGatheringStoreSubmissionMutation = (options?: Partial<Options<InformationGatheringStoreSubmissionData>>): UseMutationOptions<InformationGatheringStoreSubmissionResponse, InformationGatheringStoreSubmissionError, Options<InformationGatheringStoreSubmissionData>> => {
    const mutationOptions: UseMutationOptions<InformationGatheringStoreSubmissionResponse, InformationGatheringStoreSubmissionError, Options<InformationGatheringStoreSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await InformationGatheringService.informationGatheringStoreSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const localeGetQueryKey = (options: Options<LocaleGetData>) => createQueryKey('localeGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.LocaleController
 */
export const localeGetOptions = (options: Options<LocaleGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LocaleService.localeGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: localeGetQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.NavigationController
 */
export const navigationStartMutation = (options?: Partial<Options<NavigationStartData>>): UseMutationOptions<NavigationStartResponse, NavigationStartError, Options<NavigationStartData>> => {
    const mutationOptions: UseMutationOptions<NavigationStartResponse, NavigationStartError, Options<NavigationStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await NavigationService.navigationStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationSettingsGetComplianceSettingsQueryKey = (options?: Options<NotificationSettingsGetComplianceSettingsData>) => createQueryKey('notificationSettingsGetComplianceSettings', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.NotificationSettingsController
 */
export const notificationSettingsGetComplianceSettingsOptions = (options?: Options<NotificationSettingsGetComplianceSettingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await NotificationSettingsService.notificationSettingsGetComplianceSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationSettingsGetComplianceSettingsQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.NotificationSettingsController
 */
export const notificationSettingsUpdateComplianceSettingsMutation = (options?: Partial<Options<NotificationSettingsUpdateComplianceSettingsData>>): UseMutationOptions<NotificationSettingsUpdateComplianceSettingsResponse, NotificationSettingsUpdateComplianceSettingsError, Options<NotificationSettingsUpdateComplianceSettingsData>> => {
    const mutationOptions: UseMutationOptions<NotificationSettingsUpdateComplianceSettingsResponse, NotificationSettingsUpdateComplianceSettingsError, Options<NotificationSettingsUpdateComplianceSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await NotificationSettingsService.notificationSettingsUpdateComplianceSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const paymentsGetBillQueryKey = (options: Options<PaymentsGetBillData>) => createQueryKey('paymentsGetBill', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.PaymentsController
 */
export const paymentsGetBillOptions = (options: Options<PaymentsGetBillData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PaymentsService.paymentsGetBill({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: paymentsGetBillQueryKey(options)
    });
};

export const physicalLocationsGetPhysicalLocationQueryKey = (options: Options<PhysicalLocationsGetPhysicalLocationData>) => createQueryKey('physicalLocationsGetPhysicalLocation', options);

/**
 * Retrieves all physical locations accessible to the specified unit (inferred from the route).
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.PhysicalLocationsController
 */
export const physicalLocationsGetPhysicalLocationOptions = (options: Options<PhysicalLocationsGetPhysicalLocationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PhysicalLocationsService.physicalLocationsGetPhysicalLocation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: physicalLocationsGetPhysicalLocationQueryKey(options)
    });
};

export const physicalLocationsGetPhysicalLocationsQueryKey = (options: Options<PhysicalLocationsGetPhysicalLocationsData>) => createQueryKey('physicalLocationsGetPhysicalLocations', options);

/**
 * Retrieves all physical locations accessible to the specified unit (inferred from the route).
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.PhysicalLocationsController
 */
export const physicalLocationsGetPhysicalLocationsOptions = (options: Options<PhysicalLocationsGetPhysicalLocationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PhysicalLocationsService.physicalLocationsGetPhysicalLocations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: physicalLocationsGetPhysicalLocationsQueryKey(options)
    });
};

export const rateGetMessagingPriceQueryKey = (options: Options<RateGetMessagingPriceData>) => createQueryKey('rateGetMessagingPrice', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RateController
 */
export const rateGetMessagingPriceOptions = (options: Options<RateGetMessagingPriceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RateService.rateGetMessagingPrice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rateGetMessagingPriceQueryKey(options)
    });
};

export const recentReceptionsListRecentlyVisitedQueryKey = (options?: Options<RecentReceptionsListRecentlyVisitedData>) => createQueryKey('recentReceptionsListRecentlyVisited', options);

/**
 * Retrieve a list of the most recent receptions you have visited, in order of most recent visit first.
 * Only your latest visit on each reception will be present in the list.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
 */
export const recentReceptionsListRecentlyVisitedOptions = (options?: Options<RecentReceptionsListRecentlyVisitedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RecentReceptionsService.recentReceptionsListRecentlyVisited({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: recentReceptionsListRecentlyVisitedQueryKey(options)
    });
};

/**
 * Register a new reception visit at the current time.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
 */
export const recentReceptionsRegisterVisitMutation = (options?: Partial<Options<RecentReceptionsRegisterVisitData>>): UseMutationOptions<RecentReceptionsRegisterVisitResponse, RecentReceptionsRegisterVisitError, Options<RecentReceptionsRegisterVisitData>> => {
    const mutationOptions: UseMutationOptions<RecentReceptionsRegisterVisitResponse, RecentReceptionsRegisterVisitError, Options<RecentReceptionsRegisterVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RecentReceptionsService.recentReceptionsRegisterVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletes the reception visit for currently logged in client.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RecentReceptionsController
 */
export const recentReceptionsDeleteVisitMutation = (options?: Partial<Options<RecentReceptionsDeleteVisitData>>): UseMutationOptions<RecentReceptionsDeleteVisitResponse, RecentReceptionsDeleteVisitError, Options<RecentReceptionsDeleteVisitData>> => {
    const mutationOptions: UseMutationOptions<RecentReceptionsDeleteVisitResponse, RecentReceptionsDeleteVisitError, Options<RecentReceptionsDeleteVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RecentReceptionsService.recentReceptionsDeleteVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const receptionListFromUnitIdQueryKey = (options: Options<ReceptionListFromUnitIdData>) => createQueryKey('receptionListFromUnitId', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ReceptionController
 */
export const receptionListFromUnitIdOptions = (options: Options<ReceptionListFromUnitIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ReceptionService.receptionListFromUnitId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: receptionListFromUnitIdQueryKey(options)
    });
};

export const receptionSearchQueryKey = (options: Options<ReceptionSearchData>) => createQueryKey('receptionSearch', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.ReceptionController
 */
export const receptionSearchOptions = (options: Options<ReceptionSearchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ReceptionService.receptionSearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: receptionSearchQueryKey(options)
    });
};

/**
 * Obsolete Use StartSessionV2 instead.
 * Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
 * @deprecated
 */
export const redRobinStartSessionMutation = (options?: Partial<Options<RedRobinStartSessionData>>): UseMutationOptions<RedRobinStartSessionResponse, RedRobinStartSessionError, Options<RedRobinStartSessionData>> => {
    const mutationOptions: UseMutationOptions<RedRobinStartSessionResponse, RedRobinStartSessionError, Options<RedRobinStartSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RedRobinService.redRobinStartSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
 */
export const redRobinStartSessionV2Mutation = (options?: Partial<Options<RedRobinStartSessionV2Data>>): UseMutationOptions<RedRobinStartSessionV2Response, RedRobinStartSessionV2Error, Options<RedRobinStartSessionV2Data>> => {
    const mutationOptions: UseMutationOptions<RedRobinStartSessionV2Response, RedRobinStartSessionV2Error, Options<RedRobinStartSessionV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RedRobinService.redRobinStartSessionV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const redRobinGetPatientEntryUrlQueryKey = (options: Options<RedRobinGetPatientEntryUrlData>) => createQueryKey('redRobinGetPatientEntryUrl', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
 */
export const redRobinGetPatientEntryUrlOptions = (options: Options<RedRobinGetPatientEntryUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RedRobinService.redRobinGetPatientEntryUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: redRobinGetPatientEntryUrlQueryKey(options)
    });
};

export const redRobinGetAccessInfoQueryKey = (options: Options<RedRobinGetAccessInfoData>) => createQueryKey('redRobinGetAccessInfo', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.RedRobinController
 */
export const redRobinGetAccessInfoOptions = (options: Options<RedRobinGetAccessInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RedRobinService.redRobinGetAccessInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: redRobinGetAccessInfoQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
 */
export const searchLimitationDeleteContextMutation = (options?: Partial<Options<SearchLimitationDeleteContextData>>): UseMutationOptions<unknown, SearchLimitationDeleteContextError, Options<SearchLimitationDeleteContextData>> => {
    const mutationOptions: UseMutationOptions<unknown, SearchLimitationDeleteContextError, Options<SearchLimitationDeleteContextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SearchLimitationService.searchLimitationDeleteContext({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchLimitationGetSearchLimitationQueryKey = (options: Options<SearchLimitationGetSearchLimitationData>) => createQueryKey('searchLimitationGetSearchLimitation', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
 */
export const searchLimitationGetSearchLimitationOptions = (options: Options<SearchLimitationGetSearchLimitationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SearchLimitationService.searchLimitationGetSearchLimitation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchLimitationGetSearchLimitationQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Receptions.SearchLimitationController
 */
export const searchLimitationCreateSearchLimitationMutation = (options?: Partial<Options<SearchLimitationCreateSearchLimitationData>>): UseMutationOptions<SearchLimitationCreateSearchLimitationResponse, DefaultError, Options<SearchLimitationCreateSearchLimitationData>> => {
    const mutationOptions: UseMutationOptions<SearchLimitationCreateSearchLimitationResponse, DefaultError, Options<SearchLimitationCreateSearchLimitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SearchLimitationService.searchLimitationCreateSearchLimitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionInformationGetClientSessionInformationQueryKey = (options?: Options<SessionInformationGetClientSessionInformationData>) => createQueryKey('sessionInformationGetClientSessionInformation', options);

/**
 * Get information about the max session length for this client.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.SessionInformationController
 */
export const sessionInformationGetClientSessionInformationOptions = (options?: Options<SessionInformationGetClientSessionInformationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SessionInformationService.sessionInformationGetClientSessionInformation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sessionInformationGetClientSessionInformationQueryKey(options)
    });
};

export const sessionInformationGetGuestSessionInformationQueryKey = (options?: Options<SessionInformationGetGuestSessionInformationData>) => createQueryKey('sessionInformationGetGuestSessionInformation', options);

/**
 * Get information about the max session length to this guest.
 *  Defined in VisibaCare.Api.Client.v2.Controllers.SessionInformationController
 */
export const sessionInformationGetGuestSessionInformationOptions = (options?: Options<SessionInformationGetGuestSessionInformationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SessionInformationService.sessionInformationGetGuestSessionInformation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sessionInformationGetGuestSessionInformationQueryKey(options)
    });
};

export const translationSetsGetQueryKey = (options: Options<TranslationSetsGetData>) => createQueryKey('translationSetsGet', options);

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.TranslationSetsController
 */
export const translationSetsGetOptions = (options: Options<TranslationSetsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TranslationSetsService.translationSetsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: translationSetsGetQueryKey(options)
    });
};

export const unitsPhysicalLocationsGetPhysicalLocationsQueryKey = (options: Options<UnitsPhysicalLocationsGetPhysicalLocationsData>) => createQueryKey('unitsPhysicalLocationsGetPhysicalLocations', options);

/**
 * Retrieves all physical locations accessible to the specified unit (inferred from the route).
 *  Defined in VisibaCare.Api.Client.v2.Controllers.Units.UnitsPhysicalLocationsController
 */
export const unitsPhysicalLocationsGetPhysicalLocationsOptions = (options: Options<UnitsPhysicalLocationsGetPhysicalLocationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UnitsPhysicalLocationsService.unitsPhysicalLocationsGetPhysicalLocations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unitsPhysicalLocationsGetPhysicalLocationsQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.Client.v2.Controllers.UserFilesController
 */
export const userFilesGetFileIdentifierMutation = (options?: Partial<Options<UserFilesGetFileIdentifierData>>): UseMutationOptions<UserFilesGetFileIdentifierResponse, UserFilesGetFileIdentifierError, Options<UserFilesGetFileIdentifierData>> => {
    const mutationOptions: UseMutationOptions<UserFilesGetFileIdentifierResponse, UserFilesGetFileIdentifierError, Options<UserFilesGetFileIdentifierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserFilesService.userFilesGetFileIdentifier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};